import { render, staticRenderFns } from "./DetailLaporanPembayaran.vue?vue&type=template&id=1cb707c7&"
import script from "./DetailLaporanPembayaran.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanPembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports